module.exports = __webpack_public_path__ + "resources/img/main_banner_ngsc02_m.7e7cce9e4fbeb1b83bc7e2251a5a74a7.png";